const CallToAction = () => {
  return (
    <div className="container-fluid py-5">
      <div className="container">
        <div
          className="bg-primary rounded p-5 wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div className="row g-4 align-items-center">
            <div className="col-lg-6 text-center text-lg-start">
              <h1 className="text-white mb-4">Ready to Get Started?</h1>
              <p className="text-white mb-0 lead">
                Join thousands of employers and candidates who trust us to find
                the perfect match.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <a
                className="btn btn-light py-3 px-5 me-3 fw-bold"
                href="#register"
              >
                Find a Job
              </a>
              <a
                className="btn btn-outline-light py-3 px-5 fw-bold"
                href="#post-job"
              >
                Post a Job
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
